module.exports = __webpack_public_path__ + "static/media/incident_category-cargo.27e7aefa.svg";